var styles = {"differentialPrice":"ep-pricing-module-differential-price-ZGlmZ"};

export { styles as default };
//# sourceMappingURL=ep-pricing-esm-components-differential-price-differential-price.module.scss.js.map
